import { Box, Stack, Typography, useTheme } from '@mui/material'
import GroboticLight from '../../images/Grobotic png-lightmode.png'
import GroboticPng from '../../images/Grobotic png.png'
import './DataGridContext.css'

const InlineLoading = () => {
  const theme = useTheme()
  const letters = ['L', 'o', 'a', 'd', 'i', 'n', 'g', '', 'i', 't', 'e', 'm', 's']
  const lettersEnd = ['.', '.', '.']

  return (
    <Stack
      sx={{
        width: '100%',
        height: '100%',
        minHeight: '150px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
        borderRadius: 2,
      }}
    >
      <img
        className="loading-overlay"
        src={theme.palette.mode === 'dark' ? GroboticPng : GroboticLight}
        alt="logo"
        style={{ marginBottom: 10, width: 'auto' }}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
        }}
      >
        {letters.map((char, index) => (
          <Typography
            key={index}
            className="animated-letter"
            style={{
              animationDelay: `${index * 0.2}s`,
              fontSize: 16,
            }}
          >
            {char}
          </Typography>
        ))}
        {lettersEnd.map((char, index) => (
          <Typography
            key={`dot-${index}`}
            className="animated-letter-end"
            style={{
              animationDelay: `${index * 0.2}s`,
              fontSize: 20,
            }}
          >
            {char}
          </Typography>
        ))}
      </Box>
    </Stack>
  )
}

export default InlineLoading
